import React from 'react';
import PropTypes from 'prop-types';
import _ from 'underscore';
import {
  Button,
  Alert,
  FormGroup,
  FormControl,
  ControlLabel,
  Modal,
} from 'react-bootstrap';
import validator from 'email-validator';
import { withTranslation } from 'react-i18next';
import { titleize } from 'underscore.string';

class SendDOEmailModal extends React.Component {
  static propTypes = {
    show: PropTypes.bool.isRequired,
    onSend: PropTypes.func.isRequired,
    onHide: PropTypes.func.isRequired,
    defaultRecipient: PropTypes.string,
  };

  constructor(props) {
    super(props);
    this.state = this.getInitialState();
  }

  getInitialState() {
    return {
      error: null,
      to: this.props.defaultRecipient,
    };
  }

  componentWillUnmount() {
    this.setState(this.getInitialState());
  }

  addRecipients(e) {
    this.setState({ to: e.target.value.trim() });
  }

  send = () => {
    const emails = this.state.to.replace(/' '/g, '').split(',');
    const invalidEmailAddresses = emails.filter(
      (ea) => !validator.validate(ea),
    );
    if (invalidEmailAddresses.length > 0) {
      this.setState({ error: 'VALID_EMAIL_ONLY' });
      return;
    }

    this.props.onSend(_.uniq(emails));
    this.setState(this.getInitialState());
    this.props.onHide();
  };

  renderError() {
    const { t } = this.props;
    if (!this.state.error) {
      return '';
    }
    return <Alert bsStyle="warning">{t(this.state.error)}</Alert>;
  }

  render() {
    const { t } = this.props;
    return (
      <Modal show={this.props.show} onHide={this.props.onHide} enforceFocus={false}>
        <Modal.Header>
          <strong>{t('EMAIL_DELIVERY_ORDER')}</strong>
        </Modal.Header>
        <Modal.Body>
          {this.renderError()}
          <div>
            <FormGroup>
              <ControlLabel>
                {titleize(t('RECIPIENT', { count: 1 }))}
              </ControlLabel>
              <FormControl
                placeholder={t('COMMA_SEPARATED_EMAILS')}
                onChange={(e) => this.addRecipients(e)}
                type="text"
                value={this.state.to}
              />
            </FormGroup>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <Button type="button" onClick={this.props.onHide}>
            {titleize(t('CLOSE'))}
          </Button>
          <Button
            disabled={this.state.to === ''}
            bsStyle="primary"
            type="button"
            onClick={this.send}
          >
            {t('SEND')}
          </Button>
        </Modal.Footer>
      </Modal>
    );
  }
}

export default withTranslation()(SendDOEmailModal);
